import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import VueCookies from "vue-cookies";
// import { VueReCaptcha } from 'vue-recaptcha-v3'

const app = createApp(App);
app.use(router);
// app.use(VueReCaptcha, { siteKey: '6LfkqtgpAAAAAFTprUUew40m8l3QfutEngGivV4Z' });
app.use(VueCookies);
app.mount("#app");
